import { User } from '@/models/user';
import { Space } from 'antd';
import { SpaceProps } from 'antd/es/space';
import React from 'react';

export enum MobileDisplayMode {
  None,
  Short,
  Full,
}

export type Props = {
  user: User;
  spaceProps?: SpaceProps;
  showNickName?: boolean;
  showMobile?: MobileDisplayMode;
};

const UserName: React.FC<Props> = ({
  user,
  spaceProps = {},
  showNickName = true,
  showMobile = MobileDisplayMode.None,
}: Props) => {
  if (!user) return <>无客户信息</>;
  const { remarkName, nickname, mobile } = user;

  // 1. 主展示名称
  let mainName = '';
  let nicknameDisplay = showNickName ? nickname : '';

  if (remarkName) {
    mainName = remarkName;
  } else if (nickname) {
    mainName = nickname; // 没有 remarkName 时，尝试使用 nickname
    nicknameDisplay = ''; // 如果昵称已经作为主标题，副标题就不再重复显示
  } else {
    mainName = '匿名客户'; // 最终兜底
  }

  // 2. 处理手机号显示逻辑
  let mobileDisplay = '';
  if (mobile && showMobile !== MobileDisplayMode.None) {
    mobileDisplay = showMobile === MobileDisplayMode.Short ? mobile.slice(-4) : mobile;
  }

  return (
    <Space size={4} direction="horizontal" wrap {...spaceProps}>
      <span style={{ fontWeight: 500 }}>{mainName}</span>
      {nicknameDisplay && <span style={{ color: '#999' }}>({nicknameDisplay})</span>}
      {mobileDisplay && <span style={{ color: '#999' }}>[{mobileDisplay}]</span>}
    </Space>
  );
};

export default UserName;
